<template>
  <div class="add">
    <ErranditeIcon icon="plus" v-on:click="state.adding = true"/>
    <div class="adding" v-if="state.adding">
		<div class="close" v-on:click="closeAdd">
			<ErranditeIcon icon="angle-down"/>
		</div>
      <div class="inputs">
        <div class="item">
          <span v-if="item.text != ''">{{ item.text }}</span>
          <span class="date" v-if="item.start != null || item.end != null">
            <ErranditeIcon icon="calendar-alt"/>
            <span v-if="item.start != null">{{ formattedDate(item.start) }}</span>
			<span v-if="item.start != null && item.end != null"> to </span>
			<span v-if="item.end != null">{{ formattedDate(item.end) }}</span>
          </span>
          <span class="date" v-if="item.end != null && item.time == true">
            <ErranditeIcon icon="clock"/>
            <span v-if="item.end != null">{{ formattedTime(item.end) }}</span>
          </span>
        </div>
		<input type="text" v-model="entry" ref="add" v-on:keyup="checkEntry">
      </div>
      <ErranditeIcon icon="arrow-alt-circle-up" v-on:click="addItem"/>
    </div>
  </div>
</template>

<script>
import ErranditeIcon from "./ErranditeIcon.vue";
import * as chrono from "chrono-node";
import dayjs from "dayjs";
import { v4 as uuidv4 } from "uuid";

import { tasksCollection, usersCollection } from "./firebase";

export default {
  name: "ErranditeBreadcrumb",
  props: {
    state: Object,
    data: Object
  },
  data: function() {
    return {
      entry: "",
      item: {
        text: "",
        start: null,
        end: null,
        effort: null,
		time: false,
		tags: [],
		colour: null
      }
    };
  },
  components: {
    ErranditeIcon
  },
  computed: {},
  methods: {
    formattedDate: function(dt) {
      var day = dayjs(dt);
      var now = dayjs(new Date());
      var tomorrow = new Date();
      tomorrow.setDate(tomorrow.getDate() + 1);
	  var tom = dayjs(tomorrow);
	  var nextWeek = new Date();
	  nextWeek.setDate(nextWeek.getDate() + 6);

      if (day.format("YYYY-MM-DD") == now.format("YYYY-MM-DD")) {
        return "Today";
      } else if (day.format("YYYY-MM-DD") == tom.format("YYYY-MM-DD")) {
        return "Tomorrow";
      } else if (dt.getTime() < nextWeek.getTime()) {
		  
        return day.format("dddd");
		} else {
        return day.format("dddd D MMMM");
      }
    },
    formattedTime: function(dt) {
      var day = dayjs(dt);
      if (this.item.time == true) {
        return day.format("h:mma");
      } else {
        return "";
      }
    },
    checkEntry: function(ev) {
      var myDate = chrono.parseDate(this.entry);
      var myDateInfo = chrono.parse(this.entry);

      this.item.text = this.entry;
      this.item.start = null;
      this.item.end = null;
      this.item.effort = null;
      this.item.time = false;

      if (myDate != null) {
        this.item.text = this.entry.replace(myDateInfo[0].text, "").trim();
        if (myDateInfo[0].end != null) {
		  this.item.end =  myDateInfo[0].end.date();

          this.item.start = myDateInfo[0].start.date();
		  
		  
          console.log(myDateInfo);
          console.log(myDate);

          if (myDateInfo[0].end.knownValues.hour != undefined) {
            this.item.time = true;
          }
        } else {
          this.item.end = myDate;

          console.log(myDateInfo);
          console.log(myDate);

          if (myDateInfo[0].start.knownValues.hour != undefined) {
            this.item.time = true;
          }
        }
	  }

      if (ev.which == 13) {
        this.addItem();
      }
    },
    addItem: function() {
      var er = this;

      var myId = uuidv4();
      var newTask = {
        label: this.item.text,
		tasks: [],
		tags: [],
        completed: null,
		start: this.item.start,
		end: this.item.end,
		effort: this.item.effort,
        time: this.item.time,
		colour: null
      };

      this.$set(this.data.tasks, myId, newTask);

      var docRef = tasksCollection.doc(myId);
      docRef
        .set(newTask)
        .then(function() {
          console.log(er.data.tasks[myId]);

          if (er.state.breadcrumb.length > 0) {
            var parentTask =
              er.state.breadcrumb[er.state.breadcrumb.length - 1];
            er.data.tasks[parentTask].tasks.push(myId);

            var docRefParent = tasksCollection.doc(parentTask);
            docRefParent
              .set(er.data.tasks[parentTask])
              .then(function() {})
              .catch(function(error) {
                console.error("Error writing document: ", error);
              });
          } else {
            er.data.projects.push(myId);
            var userRef = usersCollection.doc(er.state.user.uid);
            userRef
              .set({
                projects: er.data.projects
              })
              .then(function() {})
              .catch(function(error) {
                console.error("Error writing document: ", error);
              });
          }

          er.closeAdd();
        })
        .catch(function(error) {
          console.error("Error writing document: ", error);
        });
    },
    closeAdd: function() {
      this.item.text = "";
      this.entry = "";
      this.item.datetime = null;
      this.item.time = false;
      this.state.adding = false;
    }
  },
  mounted: function() {},
  watch: {
    "state.adding": function() {
      if (this.state.adding == true) {
        var d = this;
        this.$nextTick(function() {
          d.$refs.add.focus();
        });
      }
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
@import "../styles/_variables.scss";

.add {
  .icon {
    position: fixed;
	bottom: $padding;
	bottom: calc(#{$padding} +  env(safe-area-inset-bottom));
	left: 50%;
	margin-left: -$padding - $addSize/2;
	padding: $padding;
    background-color: $highlight;
    color: $white;
    font-size: $addSize;
    width: $addSize;
    height: $addSize;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;

    &:hover {
      background-color: $highlight2;
      cursor: pointer;
    }
  }

  .adding {
    background-color: $dark2;
    position: fixed;
    bottom: 0px;
    left: 0px;
    width: 100%;
	padding: $padding/2 0 $padding 0;
	padding-bottom: calc(#{$padding} +  env(safe-area-inset-bottom));

    .icon {
	  position: relative;
	  bottom: 0px;
	}
	
	.close {
		padding-bottom: $padding/2;
		.icon {
			background: transparent;
			color: $light;
			padding: 0px;
			margin-left: -$addSize/2;
		}

		&:hover {
			.icon {
				color: $white;
			}
		}
	}

    .inputs {
      flex: 1 0 50px;
      padding: 0 $padding $padding/2 $padding;

      .item {
        vertical-align: top;
        padding: 0;

        span {
          padding: $padding/2 0 $padding/2 $padding/2;
		  margin-right: $padding/2;
		  left: 0px;
		  bottom: 0px;
		  display: inline-block;
        }
        .icon {
          width: auto;
          height: auto;
          font-size: 16px;
          padding: 0px;
          display: inline-block;
          background: transparent;
          margin: 0px;
        }

        .date {
          border-radius: $borderRadius;
		  background-color: $highlight;
		  display: inline-block;
		  margin-right: $padding/2;
		  margin-bottom: $padding/2;

          padding: $padding/2;

          span {
			margin-right: $padding/2;
			padding: 0;
          }
        }
      }

      input {
        padding: $padding;
        border: 0px;
        background-color: transparent;
        color: $white;
        width: 100%;
        box-sizing: border-box;
      }
    }
  }
}
</style>
